// extracted by mini-css-extract-plugin
export default {"headerClass":"Table_headerClass__xgMXl"};